export const SITE = {
  name: "Next Gen Properties",
  region: "Telangana",
  phone: "+91 99519 71450",
  phoneRaw: "919951971450",
  phone2: "+91 81433 61916",
  phone2Raw: "918143361916",
  whatsappNumber: "918143361916",
  email: "nextgenpropertiestelangana@gmail.com",
  address: "D. No. 2-1-46/1, 3rd Floor, Above KS Baker's, Opp. Metro Pillar No. 865, Near Uppal Ring Road, Hyderabad, TG-500039",
  hours: "Mon – Sun: 6:30 AM – 7:30 PM",
  whatsapp: (msg = "Hi, I'm interested in your open plots.") =>
    `https://wa.me/918143361916?text=${encodeURIComponent(msg)}`,
};

export const WHY = [
  { t: "Verified Projects", d: "Every layout personally verified by our legal team." },
  { t: "HMDA Approved", d: "Metropolitan authority sanctioned premium layouts." },
  { t: "DTCP Approved", d: "Town & Country planning approved growth corridors." },
  { t: "FCDA Approved", d: "Fully compliant development-area plots." },
  { t: "Bank Loan Assistance", d: "End-to-end help with home & plot loans." },
  { t: "Clear Title", d: "100% litigation-free, clear title guarantee." },
  { t: "High Returns", d: "Prime locations chosen for best appreciation." },
  { t: "Ready To Construct", d: "Roads, drainage & electricity ready plots." },
];
